export default __webpack_public_path__ + "static/media/ic_atom_40.42df1cda.svg";